import React from 'react';
import { Icon } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Summary from '@/components/Summary';
import withProps from '@/components/withProps';

const Prefix = withProps({
  name: 'flightRight',
})(Icon);

const LeadInHeroSummary = ({ nights }) => {
  if (!nights) {
    return <Summary text="FLIGHTS + HOTEL" prefix={<Prefix />} />;
  }

  return (
    <Summary text={`FLIGHTS + ${nights} NIGHT STAY FROM`} prefix={<Prefix />} />
  );
};

LeadInHeroSummary.propTypes = {
  nights: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default LeadInHeroSummary;
